export function formatCurrency(value: number, currency = 'GEL'): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    currencyDisplay: 'code',
  }).format(value);
}
